//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import errGif from "../../assets/img/noPermission.png";
export default {
  props: ['pData'],
  data: function data() {
    return {
      errGif: errGif + '?' + +new Date(),
      ewizardClap: 'https://wpimg.wallstcn.com/007ef517-bafd-4066-aae4-6883632d9646',
      dialogVisible: false
    };
  },
  methods: {
    back: function back() {
      if (this.$route.query.noGoBack) {
        this.$router.push({
          path: '/dashboard'
        });
      } else {
        this.$router.go(-1);
      }
    },
    gotoDataScreening: function gotoDataScreening() {
      if (this.pData.dept.branchUnitId) {
        if (this.pData.dept.branchUnitId === 'dept-20230209092043-mq40sqtk' || this.pData.dept.branchUnitId === 'dept-20190923113717-1j4004gd') {
          this.$router.push({
            path: '/main/international/dataScreening'
          });
        } else {
          this.$router.push({
            path: '/main/dataScreening'
          });
        }
      } else {
        this.$router.push({
          path: '/main/dataScreening'
        });
      }
    }
  }
};